"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFinalNegotiationParticipantDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
class CreateFinalNegotiationParticipantDto {
    constructor(participantId) {
        this.participantId = participantId;
    }
}
exports.CreateFinalNegotiationParticipantDto = CreateFinalNegotiationParticipantDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 101,
        description: "ID of the participant (employee)",
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Participant ID is required" }),
    (0, class_validator_1.IsInt)({ message: "Participant ID must be an integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateFinalNegotiationParticipantDto.prototype, "participantId", void 0);
